import axios from 'axios';
import { handleAuthError } from '../funciones/authHelper';

const API_URL = process.env.REACT_APP_API_URL;

export const fetchDocumentos = async (paginaActual = 1, registrosPorPag = 10, busqueda = null, usuarioId = null, empresaId = null, departamentoId = null, ordenarColumna = "", orden = "") => {
    try {
        const response = await axios.post(`${API_URL}/api/documentos/permitidos`, {
            "current_page": paginaActual,
            "items_per_page": registrosPorPag,
            "filteredWord": busqueda,
            "usuario_id": usuarioId,
            "empresa_id": empresaId,
            "departamento_id": departamentoId,
            "order": {
                "orderColumn": ordenarColumna,
                "order": orden
            }
        }, {
            headers: { 
                'Authorization': `Bearer ${localStorage.getItem("token")}`
            }
        });
        return response.data;
    } catch (error) {
        handleAuthError(error);
    }
};

export const fetchObtenerDocumento = async (documentoId) => {
    try {
        const response = await axios.get(`${API_URL}/api/documentos/obtener/${documentoId}`, {
            headers: {
                'Authorization': `Bearer ${localStorage.getItem("token")}`
            },
            responseType: 'blob'
        });
        return response;
    } catch (error) {
        handleAuthError(error);
    }
};

export const fetchTodosDocumentos = async (paginaActual = 1, registrosPorPag = 10, busqueda = null, usuarioId = null, empresaId = null, departamentoId = null, ordenarColumna = "", orden = "") => {
    try {
        const response = await axios.post(`${API_URL}/api/documentos`, {
            "current_page": paginaActual,
            "items_per_page": registrosPorPag,
            "filteredWord": busqueda,
            "usuario_id": usuarioId,
            "empresa_id": empresaId,
            "departamento_id": departamentoId,
            "order": {
                "orderColumn": ordenarColumna,
                "order": orden
            }
        }, {
            headers: { 
                'Authorization': `Bearer ${localStorage.getItem("token")}`
            }
        });
        return response.data;
    } catch (error) {
        handleAuthError(error);
    }
};

export const eliminarDocumento = async (documentosId) => {
    try {
        const idsArray = Array.isArray(documentosId) ? documentosId : [documentosId];
        
        const response = await axios.post(`${API_URL}/api/documentos/eliminar`, {
            ids: idsArray
        }, {
            headers: { 
                'Authorization': `Bearer ${localStorage.getItem("token")}`
            }
        });
        return response.data;
    } catch (error) {
        handleAuthError(error);
    }
};

export const subirDocumento = async (formData) => {
    try {
        const response = await axios.post(`${API_URL}/api/documentos/subir`, formData, {
            headers: { 
                'Authorization': `Bearer ${localStorage.getItem("token")}`,
                'Content-Type': 'multipart/form-data'
            }
        });
        return response.data;
    } catch (error) {
        handleAuthError(error);
    }
};

export const editarPermisosDocumento = async (documentoId, permisos, nombreDocumento = null) => {
    try {
        const payload = {
            permisos: permisos
        };

        if (nombreDocumento) {
            payload.nombre = nombreDocumento;
        }

        const response = await axios.post(`${API_URL}/api/documentos/permisos/${documentoId}`, payload, {
            headers: {
                'Authorization': `Bearer ${localStorage.getItem("token")}`
            }
        });
        return response.data;
    } catch (error) {
        handleAuthError(error);
    }
};
